const uuidPattern = /\b[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/ig;

export const isUuid = (value) => (
    typeof value === 'string' && value.trim().match(uuidPattern)?.[0] === value.trim()
);

export const withoutUuid = (value, fallback = '') => {
    if (value === null || value === undefined) return fallback;

    const text = String(value).replace(uuidPattern, '').replace(/\s{2,}/g, ' ').trim();
    return text || fallback;
};

export const firstNonUuid = (...values) => {
    for (const value of values) {
        if (value === null || value === undefined || value === '') continue;
        if (!isUuid(String(value))) return value;
    }

    return '';
};
